import React from 'react';
import { Twitter } from 'lucide-react';
import logo from '../logo.png';

const Header = () => {
    return (
        <header className="fixed top-10 w-full z-50 bg-black/10 backdrop-blur-md border-b border-white/10">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <img src={logo} alt="TITSTR Logo" className="w-12 h-12 object-contain animate-pulse-slow" />
                    <h1 className="text-2xl font-bold tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-purple-600">
                        $TITSTR
                    </h1>
                </div>

                <div className="flex items-center gap-4">
                    <a
                        href="https://www.tokenstrategy.com/strategies/0x6b6994b20be17f193d67886592b3dad5df594060"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-4 py-1.5 md:px-6 md:py-2 text-sm md:text-base bg-green-500 hover:bg-green-600 text-black font-bold rounded-full transition-all duration-300 transform hover:scale-105"
                    >
                        BUY
                    </a>
                    <a
                        href="https://x.com/titstreth"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-white/5 hover:bg-white/10 hover:text-blue-400 transition-all duration-300"
                        aria-label="Twitter"
                    >
                        <Twitter className="w-5 h-5 md:w-6 md:h-6" />
                    </a>
                    <a
                        href="https://t.me/titstrportal"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-white/5 hover:bg-white/10 hover:text-blue-400 transition-all duration-300"
                        aria-label="Telegram"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-5 h-5 md:w-6 md:h-6"
                        >
                            <line x1="22" y1="2" x2="11" y2="13"></line>
                            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                        </svg>
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Header;
